import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../redux/slices/authSlice";
import newApplicantsReducer from "../redux/slices/newApplicantsSlice";
import incompletApplicationReducer from "../redux/slices/incompletApplicationSlice";
import tablesReducer from "../redux/slices/tablesSlice";
import generalReducer from "../redux/slices/generalSlice";
import dashboardReducer from "../redux/slices/dashboardSlice";
import reportReducer from "./slices/reportSlice";
import organizationReducer from "../redux/slices/organizationSlice";

const authPersistConfig = {
    key: "auth",
    version: 1,
    storage,
    whitelist: ["user", "isUserVerified", "active"],
};

// Persist configuration for dashboard slice
const dashboardPersistConfig = {
    key: "dashboard",
    version: 1,
    storage,
    whitelist: ["dashboardData"],
};

const tablePersistConfig = {
    key: "table",
    version: 1,
    storage,
    whitelist: ["renewalStatus"],
};

const persistedReducer = persistReducer(authPersistConfig, authReducer);
const persistedDashboardReducer = persistReducer(dashboardPersistConfig, dashboardReducer);
const persistedTableReducer = persistReducer(tablePersistConfig, tablesReducer);

export const store = configureStore({
    reducer: {
        auth: persistedReducer,
        newApplicants: newApplicantsReducer,
        incompletApplications: incompletApplicationReducer,
        table: persistedTableReducer,
        general: generalReducer,
        dashboard: persistedDashboardReducer,
        reports: reportReducer,
        organizations: organizationReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);
